<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    :return-value.sync="lazyValue"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="dateValue"
        prepend-inner-icon="mdi-calendar"
        readonly
        v-bind="$attrs"
        clearable
        v-on="on"
        @click:clear="this.$emit('cleared')"
      ></v-text-field>
    </template>
    <v-date-picker
      color="primary"
      v-model="lazyValue"
      :type="$attrs['dateType'] || 'date'"
      no-title
      scrollable
      :min="minDateFormatado"
      :max="maxDateFormatado"
      @change="onDateChange"
    >
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="menu = false">Cancelar</v-btn>
      <v-btn text color="primary" @click="onSaveClick"> OK </v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
import moment from "moment";

export default {
  name: "AnalisesMenuDatepicker",
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    value: null,
    minDate: String,
    maxDate: String,
    displayFormat: {
      type: String,
      default: () => "DD/MM/Y",
    },
  },
  data() {
    return {
      menu: false,
      lazyValue: this.value,
    };
  },
  methods: {
    onSaveClick() {
      this.$emit("change", this.dateValue);
      this.$refs.menu.save(this.lazyValue);
    },
    onDateChange() {
      this.$emit("change", this.dateValue);
      this.$refs.menu.save(this.lazyValue);
    },
  },
  computed: {
  	minDateFormatado() {
  		if (!this.minDate) return null
  		return moment(this.minDate, 'DD/MM/YYYY').format()
	  },
  	maxDateFormatado() {
  		if (!this.maxDate) return null
  		return moment(this.maxDate, 'DD/MM/YYYY').format()
	  },
    dateValue: {
      get() {
        if (!this.lazyValue) return "";
        const parsedDate = moment(this.lazyValue);
        if (!parsedDate.isValid()) return "";
        return moment(this.lazyValue).format(this.displayFormat);
      },
      set(value) {
        this.lazyValue = value;
        this.$emit("change", this.dateValue);
        this.$refs.menu.save(this.lazyValue);
      },
    },
  },
};
</script>

<style scoped></style>